import * as PropTypes from 'prop-types';

interface SymbolProps {
  initials: string;
  circle?: boolean;
  color?: string; // Accepts hex color like '#FF6B6B'
}

const InitialsSymbol: React.FC<SymbolProps> = ({
                                                 initials,
                                                 circle = false,
                                                 color = '#00B894', // Default fallback
                                               }) => {
  const backgroundColor = hexToRgba(color, 0.1);

  return (
      <div
          className={`symbol symbol-40px user-select-none ${
              circle ? 'symbol-circle' : ''
          }`}
      >
        <div
            className="symbol-label fw-bold fs-3"
            style={{
              color,
              backgroundColor,
            }}
        >
          {initials}
        </div>
      </div>
  );
};

function hexToRgba(hex: string, alpha: number): string {
  const cleanHex = hex.replace('#', '');
  const bigint = parseInt(cleanHex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export default InitialsSymbol;

InitialsSymbol.propTypes = {
  initials: PropTypes.string.isRequired,
  circle: PropTypes.bool,
  color: PropTypes.string,
};
